import _defineProperty from "@babel/runtime/helpers/defineProperty";
import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import { Color as PaletteColor } from '../../utils/types/palette';
import { Size } from './types';
var baseClassName = 'CrossButton';
var crossButtonPaddingMixin = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Size.Xs, css(["padding:5px;height:20px;"])), Size.Sm, css(["padding:6px;height:24px;"])), Size.Md, css(["padding:9px;"])), Size.Lg, css(["padding:12px;"]));
var CrossButton = /*#__PURE__*/styled.button.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-ygfku-0"
})(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Size.Lg : _ref$size,
    theme = _ref.theme;
  return css(["display:flex;justify-content:center;align-items:center;cursor:pointer;border-radius:4px;", " color:", ";background:transparent;border:none;transition:all 100ms ease-out;&:hover{color:", ";background:", ";}&:active{color:", ";background:", ";}"], crossButtonPaddingMixin[size], theme.palette[PaletteColor.IconsSecondary], theme.palette[PaletteColor.IconsPrimary], theme.palette[PaletteColor.BackgroundHover], theme.palette[PaletteColor.IconsPrimaryHover], theme.palette[PaletteColor.BackgroundActive]);
});
var Styled = applyDisplayNames({
  CrossButton: CrossButton
});
export default Styled;